import { memo, useEffect, useMemo } from 'react';
import _get from 'lodash/get';
import { IAppContextStore, useAppContext } from '../../../context/app-context';
import { IProgramSection } from '../program';
import { Entry } from 'contentful';
import { filterItems } from '../../../helpers/contentful-helper';

const InquiryFormsection: React.FC = () => {
  const { rawContentFul }: IAppContextStore = useAppContext();
  const inquiryFormSection: Entry<IProgramSection> = useMemo(() => (
    filterItems(rawContentFul, 'newHomepageInquiryFormSection')?.[0]
  ) as Entry<IProgramSection>, [rawContentFul]);

  useEffect(() => {
    const script = document.createElement('script');
    script.id = 'inquiry-form-script';
    script.src = _get(inquiryFormSection, 'fields.inquiryFormScriptUrl', '');
    script.async = true;
    const inquiryForm = document.querySelector('#inquiry-form-content');

    if (!document.querySelector('#inquiry-form-script')) {
      inquiryForm?.appendChild(script);
    }

    return () => {
      inquiryForm?.removeChild(script);
    };
  }, [inquiryFormSection]);

  return (
    <section id='inquiry-form' className='bg-[#F8F9FA] relative w-full px-4 py-8 md:py-16'>
      <div className='text-center'>
        <h2 className='text-22 md:text-40 md:leading-[48px] font-bold
          max-w-[260px] md:max-w-4xl w-full mx-auto font-inter mb-5'>
          {_get(inquiryFormSection, 'fields.title', '')}
        </h2>
        <p className='text-18 md:text-20 leading-7 mb-4 font-sans'>
          {_get(inquiryFormSection, 'fields.description', '')}
        </p>
        <div id='inquiry-form-content' />
      </div>
    </section>
  );
}

export default memo(InquiryFormsection);
